import APIS from '../api/fileAxios/fileAxios';
import OSS from 'ali-oss';

/**
 * @param config
 * @param config.originalFilename 文件名
 * @param config.contentType 文件类型
 * @param config.service 服务名称
 * @param config.module 服务内模块名
 * @param config.userId  用户id
 * @returns {Promise<unknown>}
 */
export function getKeysInfo (config) {
  return new Promise((resolve, reject) => {
    APIS.getAliTempKeyInfo(config).then(({ status, data }) => {
      if (Number(status) === 200) {
        const OSSConfig = {
          region: data.data.region, // 测试默认 后期后端提供
          accessKeyId: data.data.accessKeyId,
          accessKeySecret: data.data.accessKeySecret,
          stsToken: data.data.securityToken,
          objectName: data.data.objectName,
          bucket: data.data.bucketName
        };
        resolve(OSSConfig);
      }
    }).catch((e) => reject(e));
  });
};

/**
 * @desc 构建OSS
 * @param config
 * @param config.originalFilename 文件名
 * @param config.contentType 文件类型
 * @param config.service 服务名称
 * @param config.module 服务内模块名
 * @param config.userId  用户id
 * @param config.privateBucket 私有桶 默认true
 * @returns {Promise<OSS>}
 */
const OSSClient = (config) => {
  return new Promise((resolve, reject) => {
    getKeysInfo(config)
      .then((config) => {
        const client = new OSS({
          region: config.region,
          accessKeyId: config.accessKeyId,
          accessKeySecret: config.accessKeySecret,
          stsToken: config.stsToken,
          bucket: config.bucket
        });
        resolve({ client, config });
      })
      .catch((e) => reject(e));
  });
};

/**
 * @desc 单纯的upLoad
 * @param file
 * @param config
 * @param onProgress
 * @param {Function} [cancel] 获取取消方法
 * @returns {Promise<unknown>}
 */

export const uploadFile = ({ file, config, onProgress, cancel  }) => {
  return new Promise((resolve, reject) => {
    OSSClient(config).then(({ client, config: { objectName } }) => {
      cancel && cancel(client);
      client
        .multipartUpload(objectName, file, {
          headers: {
            'x-oss-forbid-overwrite': 'false'
          },
          parallel: 4,
          partSize: 1024 * 1024,
          progress: (progress) => {
            onProgress && onProgress(progress);
          }
        })
        .then((res) => {
          resolve(res);
        })
        .catch((e) => reject(e));
    });
  });
};

/**
 * @desc 保存阿里上传记录
 * @param params
 * @param params.originalFilename 文件名
 * @param params.size 文件大小
 * @param params.contentType 文件类型
 * @param params.service 服务名称
 * @param params.module 服务内模块名
 * @param params.userId  用户id
 * @param params.privateBucket 私有桶 默认true
 * @param params
 * @returns {Promise<unknown>}
 */
export const saveFileInfo = (params) => {
  return new Promise((resolve, reject) => {
    APIS.saveALiFileInfo(params)
      .then(({ status, data }) => {
        if (Number(status) === 200) {
          resolve(data);
        }
      })
      .catch((e) => reject(e));
  });
};

/**
 * @desc 转换成 number
 * @param {any}
 * @returns {number}
 */
export function getNum (value) {
  return Number(value || 0) || 0;
}



// WEBPACK FOOTER //
// ./src/utils/upload.js